import { render, staticRenderFns } from "./KeyVisits.vue?vue&type=template&id=545ce074&scoped=true&"
import script from "./KeyVisits.vue?vue&type=script&lang=tsx&"
export * from "./KeyVisits.vue?vue&type=script&lang=tsx&"
import style0 from "./KeyVisits.vue?vue&type=style&index=0&id=545ce074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ce074",
  null
  
)

export default component.exports